const LogoConffetiIcon = ({
  width,
  height,
}: {
  width?: number
  height?: number
}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 40 40"
      fill="none"
      role="image"
      aria-labelledby="confeti-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="confeti-icon" />
      <g clipPath="url(#clip0_3317_54935)">
        <path
          d="M22.4876 26.8987L23.6201 28.0312L25.9487 25.7026L24.8162 24.5701L22.4876 26.8987Z"
          fill="#56AFD1"
        />
        <path
          d="M34.3621 12.0237L35.4946 13.1562L37.8233 10.8276L36.6907 9.69506L34.3621 12.0237Z"
          fill="#56AFD1"
        />
        <path
          d="M5.28925 7.6533L5.54541 9.23438L8.7962 8.70769L8.54003 7.12662L5.28925 7.6533Z"
          fill="#FFBC0D"
        />
        <path
          d="M34.3171 19.8486L34.5732 21.4297L37.824 20.903L37.5679 19.3219L34.3171 19.8486Z"
          fill="#FFBC0D"
        />
        <path
          d="M0.00218165 17.9183L2.19873 20.375L3.39359 19.3067L1.19704 16.85L0.00218165 17.9183Z"
          fill="#DB0007"
        />
        <path
          d="M36.6106 29.9417L38.8071 32.3984L40.002 31.3301L37.8054 28.8734L36.6106 29.9417Z"
          fill="#DB0007"
        />
        <path
          d="M1.51938 31.7024L1.83008 33.2734L5.06068 32.6346L4.74999 31.0635L1.51938 31.7024Z"
          fill="#FFBC0D"
        />
        <path
          d="M22.3872 8.14892L23.0781 9.59375L26.0491 8.1731L25.3582 6.72827L22.3872 8.14892Z"
          fill="#DB0007"
        />
        <path
          d="M25.411 11.9141C23.2674 11.9141 21.3589 14.7637 20.104 19.2078C18.8491 14.7637 16.9408 11.9141 14.797 11.9141C11.0325 11.9141 8 21.4038 8 33.0896H11.0325C11.0325 22.2405 12.7319 13.4303 14.8236 13.4303C16.9153 13.4303 18.6147 21.5607 18.6147 31.5734H21.6472C21.6472 21.5607 23.3466 13.4303 25.4383 13.4303C27.53 13.4303 29.2294 22.2403 29.2294 33.0896H32.2097C32.2081 21.3776 29.1756 11.9141 25.411 11.9141Z"
          fill="#FFBC0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_3317_54935">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LogoConffetiIcon
